import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { RestApiService } from '../common-app/service/rest-api.service';
import { DateUtil } from '../common-app/util/date-util';
import { Kvaw0800Vo } from './kvaw0800.vo';

/**
 * サーバとの通信を行う。
 * @see WebAPI仕様_KVAW0800（送信済日報一覧取得）.xlsx
 */
@Injectable()
export class Kvaw0800Service {

  /** 検索対象 */
  private static TARGET = 'kvaw0800';

  constructor(
    private restApiService: RestApiService,
  ) { }

  /**
   * 送信済日報一覧を検索する
   */
  searchSentReports(): Observable<Kvaw0800Vo> {
    const now: Date = new Date();
    const query = {
      deliveryDateFrom: DateUtil.format(DateUtil.adjustWithDays(now, -14), 'YYYYMMDD'),
      deliveryDateTo: DateUtil.format(now, 'YYYYMMDD'),
    };

    return this.restApiService.search<Kvaw0800Vo>(Kvaw0800Service.TARGET, query);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/kvaw0800.service.ts